import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  cursorPointer: {
    cursor: "pointer",
  },
}));

export default styles;
